export const SURVEY_QUESTION_IDS = {
  FITNESS_LEVEL: 'collectionName',
  CATEGORY_FAVORITES: 'categoryFavorites',
} as const;

export type SurveyQuestionId = (typeof SURVEY_QUESTION_IDS)[keyof typeof SURVEY_QUESTION_IDS];
